import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormIndicatorWarning(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 22h16c1.54 0 2.5-1.67 1.73-3L14 3c-.77-1.33-2.69-1.33-3.46 0L2.27 19c-.77 1.33.19 3 1.73 3Z"
        fill="#E1943E"
      />
      <path d="M12 8a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Z" fill="#fff" />
      <circle cx="12" cy="17" r="1" fill="#fff" />
    </BaseIcon>
  );
}
